import {createApp} from 'vue'
import App from './App.vue'
import router from './router/index'
import 'babel-polyfill'
import service from './http/interceptor';// 拦截，引入axios
import utils from './libs/utils'         // 引入公共方法类
import datum from './libs/datum'         // 引入公共方法类
import './styles/style.less'             // 引入公共样式
import Vant from 'vant'                  // 引入Vant
import 'vant/lib/index.css';             // 引入vant组件样式
import titleItem from './components/home/titleItem';// 2. 引入自定义组件样式
import headerTitle from "@/components/home/headerTitle";
import VideoPlayer from 'vue-video-player/src' //引入视频播放
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import share from '@/libs/share';
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});
const app = createApp(App)
app.use(router);
app.config.globalProperties.productionTip = false
app.config.globalProperties.$axios = service;
app.config.globalProperties.$share = share;
app.config.globalProperties.$utils = utils;
app.config.globalProperties.$datum = datum;
app.config.globalProperties.$company = "安徽四建控股集团有限公司";
app.use(Vant)
app.use(VideoPlayer)
app.component('titleItem', titleItem)
app.component('headerTitle', headerTitle)

app.mount('#app')
